export const whiteColor = '#ffffff';
export const blackColor = '#000000';
export const offWhiteColor ="#EDEDED";
export const blueColor = '#155DE9';
export const darkBlueColor = '#0036A0';
export const strokeColor = '#E8E8E8'; 
export const lightBlueColor = '#79A6FF';
export const redHighlightColor = '#FF6363';
export const greenHighlightColor='#04B800';
export const whitishBlueColor = '#C8DBFF';